var map = {
	"./All_Consoles 2.png": 8015,
	"./All_Consoles.png": 4413,
	"./All_Games 2.png": 4324,
	"./All_Games.png": 5310,
	"./Atari_2600.png": 5053,
	"./Microsoft_Xbox.png": 7415,
	"./Microsoft_Xbox_360.png": 6771,
	"./Microsoft_Xbox_One.png": 6354,
	"./Most_Wanted.png": 9206,
	"./NEC_PC_Engine.png": 9928,
	"./NEC_PC_Engine_CD.png": 1548,
	"./Nintendo_3DS.png": 4849,
	"./Nintendo_64.png": 2527,
	"./Nintendo_DS.png": 350,
	"./Nintendo_Entertainment_System.png": 9751,
	"./Nintendo_Famicom_Disk_System.png": 6605,
	"./Nintendo_GameCube.png": 5592,
	"./Nintendo_Game_Boy.png": 6608,
	"./Nintendo_Game_Boy_Advance.png": 2719,
	"./Nintendo_Game_Boy_Color.png": 5596,
	"./Nintendo_Pokemon_Mini.png": 2970,
	"./Nintendo_Switch.png": 1033,
	"./Nintendo_Switch_2.png": 3618,
	"./Nintendo_Virtual_Boy.png": 9347,
	"./Nintendo_Wii.png": 2452,
	"./Nintendo_Wii_U.png": 3536,
	"./PC_Engine_CD.png": 8869,
	"./SNK_Neo_Geo_CD.png": 1960,
	"./SNK_Neo_Geo_Pocket_Color.png": 8215,
	"./Sega_32X.png": 2891,
	"./Sega_CD.png": 2861,
	"./Sega_Dreamcast.png": 9274,
	"./Sega_Game_Gear.png": 6674,
	"./Sega_Genesis.png": 6376,
	"./Sega_Master_System.png": 9412,
	"./Sega_SG-1000.png": 1774,
	"./Sega_Saturn.png": 3105,
	"./Sony_PSP.png": 7306,
	"./Sony_Playstation.png": 2233,
	"./Sony_Playstation_2.png": 210,
	"./Sony_Playstation_3.png": 5035,
	"./Sony_Playstation_4.png": 1172,
	"./Sony_Playstation_5.png": 5069,
	"./Sony_Playstation_Vita.png": 3544,
	"./Soundtracks.png": 7334,
	"./Super_Nintendo_Entertainment_System.png": 1347,
	"./WonderSwan.png": 5721,
	"./WonderSwan_Color.png": 3085,
	"./default.png": 7692,
	"./favorites.png": 6788,
	"./stats.png": 4906
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7976;